import { Controller } from 'stimulus';
import SmoothScroll from 'smooth-scroll';
import flatpickr from 'flatpickr';
import { submitForm } from 'init/ajax';
import { easeOutExpo } from '../../utils/easings';
import {
  scrollOffset,
  scrollPosition
} from '../../utils/scroll';
import {
  isOldIE
} from '../../utils/support';

export default class extends Controller {
  static targets = [
    'datepicker',
    'form',
    'success',
    'submit'
  ]

  state = {
    instances: false,
    format: {
      form: 'yyyy-MM-dd',
      human: 'MM/dd/yyyy',
      placeholder: 'yyyy-mm-dd'
    },
    config: {
      showMonths: 1,
      minDate: 'today',
      monthSelectorType: 'static'
    },
    smoothScroll: new SmoothScroll(),
    grecaptchaSiteKey: '',
    isOldIE: isOldIE()
  }

  connect() {
    const {
      state
    } = this;
    this.inFlight = false;
    this.original = this.formTarget.innerHTML;
    this.ogSubmit = this.submitTarget.innerHTML;
    // fetch the recaptcha site key from a data attribute on the contact form component
    state.grecaptchaSiteKey = this.element.dataset.recaptchaSiteKey || '';
    this.initRecaptcha();
    if (!state.isOldIE) {
      this.initDatepickers();
    } else {
      this.updateDatePickerFieldsPlaceholder();
    }
  }

  initDatepickers() {
    const {
      state
    } = this;
    state.instances = flatpickr(this.datepickerTargets, state.config);
  }

  initRecaptcha() {
    const {
      state
    } = this;
    setTimeout(() => {
      grecaptcha.ready(() => {
        grecaptcha.execute(state.grecaptchaSiteKey, {action: 'contact_form'}).then(function(token) {
          const recaptchaTokenField = document.getElementById('contact_form_recaptcha_token_contact_form')
          if (recaptchaTokenField) {
            recaptchaTokenField.value = token;
          }
        });
      });
    }, 500)
  }

  updateDatePickerFieldsPlaceholder() {
    const {
      state
    } = this;
    if (this.hasDatepickerTarget) {
      Array.from(this.datepickerTargets).forEach((input) => {
        const field = input;
        field.placeholder = state.format.placeholder;
      });
    }
  }

  async submit(event) {
    event.preventDefault();

    if (this.inFlight) { return; }

    const form = event.target;
    // Consider everything valid if browser validations aren't supported
    if (!form.reportValidity || form.reportValidity()) {
      this.disableSubmit();
      let response = await submitForm(form);
      this.submitted();
    }
  }

  submitted() {
    this.formTarget.classList.add('hide');
    this.successTarget.classList.add('show');
    this.formTarget.innerHTML = this.original;
    this.submitTarget.disabled = false;
    this.inFlight = false;
    this.submitTarget.innerHTML = this.ogSubmit;
  }

  disableSubmit() {
    this.submitTarget.disabled = true;
    this.inFlight = true;
    this.submitTarget.querySelector('span').innerHTML = 'Submitting...';
  }
}
